module.exports = __webpack_public_path__ + "img/maiko.c07e3dd4.jpg";